angular.module('angus.controllers').controller('sideMenuController', [
    '$rootScope', '$scope', 'actionViewTemplates', 'constantsService', 'dashboardsService', 'logoService', 'modalService', 'nextGenNavigationService', 'restrictedAccessService', 'sideMenuService', 'subscriberService', 'userService', 'widgetPackageService',
    function ($rootScope, $scope, actionViewTemplates, constantsService, dashboardsService, logoService, modalService, nextGenNavigationService, restrictedAccessService, sideMenuService, subscriberService, userService, widgetPackageService) {

        /* Side Menu Status */
        $scope.isSideMenuOpen = sideMenuService.isSideMenuOpen();



        /* Toggles */
        $scope.toggles = {
            adept: false,
            admin: false,
            alerts: false,
            ams: false,
            dashboards: true,
            impersonation: false,
            imports: false,
            snapshots: false,
            tank: false,
            inventory: false
        };


        /*** Main Menu Access ***/
        const isSysAdmin = $rootScope.user && $rootScope.user.isSysAdmin;
        if (isSysAdmin) {
            $scope.recentImpersonations = $rootScope.user.profile && $rootScope.user.profile.recentImpersonations;
        }

        $scope.access = {
            /* Admin */
            admin: false,
            sysAdmin: isSysAdmin, //Since this property is used in a lot of places wil l revisit for refactor

            /* ADEPT */
            adept: false,
            adeptRuns: isSysAdmin,

            /* Alerts */ /* Right now SysAdmin only. But the screen was designed for non-sysadmins too and can be enabled for clients when we are ready */
            alerts: false,
            alertsManagement: isSysAdmin,
            alertResults: isSysAdmin,

            /* AMS */
            ams: isSysAdmin, /* Right now the AMS menu is only available to SysAdmins. We'll need to expand on this later if we're giving access to any items under TMS to clients */
            monitorInventory: isSysAdmin,
            monitorCompliance: isSysAdmin,

            /* Impersonation */
            impersonation: $scope.recentImpersonations && $scope.recentImpersonations.length > 0,

            /* Imports */
            imports: false,
            closingQuotes: isSysAdmin,
            timesheet: false,
            monitorInventoryImport: isSysAdmin,

            /* NextGen */
            nextGen: isSysAdmin || $rootScope.user.isBetaTester,

            /* Tank */
            tank: true,
            tankOverview: true,

            /* Inventory */
            inventory: false,
            inventoryTransactionReport: false,

            /* Snaphot */
            snapshots: false,

        }

        /* Import menu is available if the user has access to any of the imports */
        function setImportsAccess() {
            $scope.access.imports = $scope.access.closingQuotes || $scope.access.timesheet;
        }

        setImportsAccess();

        /* Inventory menu is available if the user has access to any of the inventory */
        function setInventoryAccess() {
            $scope.access.inventory = $scope.access.inventoryTransactionReport;
        }

        /* ADEPT Menu is available if the user has access to any of the items within the menu */
        function setAdeptAccess() {
            $scope.access.adept = $scope.access.adeptRuns
        }

        setAdeptAccess();
        /* Alerts menu is available if the user has access to any of the alerts */
        function setAlertsAccess() {
            $scope.access.alerts = $scope.access.alertsManagement || $scope.access.alertResults;
        }

        setAlertsAccess();

        /* Set access for Admin or sysadmin and sets restrictive accesses for BOL report */
        /* Timesheet - Right now it's for One Client Only. Not ideal, but this will work for now...*/
        /* Set access for Inventory Transaction report */
        Promise.all([restrictedAccessService.getAccess(), subscriberService.getLegacy($rootScope.user.subscriberId)]).then(function(accessAndSubscriber){
            var access = accessAndSubscriber[0];
            var subscriber = accessAndSubscriber[1];

            $scope.access.admin = _.some(access.adminAccess, function (value) {
                return value;
            }) || access.role === "sysadmin";

            $scope.access.timesheet = subscriber.code === "C-00530";
            $scope.access.inventoryTransactionReport = !access.restrictedAccess.costAndMargin || subscriber.isAngus;

            setImportsAccess();
            setInventoryAccess();
        })

        /* Access based on Widget Packages */
        widgetPackageService.get(false, $rootScope.user.securityGroupId)
            .then(function (userWidgetPackages) {

                const widgetPackageKeys = userWidgetPackages.map(function(widgetPackage) {
                    return widgetPackage.widgetPackageKey;
                });
                
                /* Snaphot - Access is granted if they have access to the Snapshot widget package
                     NOTE: From what I can tell no Subscribers have this WidgetPackage in Production. If a Subscriber is given access to the Package than this may not work still. 
                     The Services Get method only returns Widget Packages that are associated with the Subscriber, and the Package must have at least one widget that the Security Group has access too. 
                     This Package has no widgets under it, so that logic will never work. */
                $scope.access.snapshots = widgetPackageKeys.includes(constantsService.widgetPackages.snapShots);

               
            });

        /* Access based on Widgets */            
        widgetPackageService.getWidgets()
            .then(function(widgets){
                /* ADEPT Runs - Access is granted if they are a sysadmin or have access to an ADEPT widget */
                if (isSysAdmin) {
                    $scope.access.adeptRuns = true;
                }
                else {
                    $scope.access.adeptRuns = widgets.find(function(widget) {
                        return widget.widgetPackageKeys.includes(constantsService.widgetPackages.adept);
                    });
                }
                setAdeptAccess();

                /* Alerts Management asnd Results - Access is granted if they are a sysadmin or have access to an Alerts widget*/
                if (isSysAdmin) {
                    $scope.access.alertsManagement = true;
                    $scope.access.alertResults = true;
                }
                else {
                    var accessToAlerts = widgets.find(function(widget) {
                        return widget.widgetPackageKeys.includes(constantsService.widgetPackages.alerts);
                    });
                    $scope.access.alertsManagement = accessToAlerts;
                    $scope.access.alertResults = accessToAlerts;
                }
                setAlertsAccess();
            });


        $scope.closeSideMenu = function () {
            sideMenuService.close();
        }

        $scope.toggleItem = function (item) {
            $scope.toggles[item] = !$scope.toggles[item];
        }

        $scope.openNextGen = function() {
            nextGenNavigationService.openNextGenInNewContext();
        }

        $scope.$watch(
            function () {
                return sideMenuService.isSideMenuOpen();
            },
            function (newSideMenuStatus, oldSideMenuStatus) {
                $scope.isSideMenuOpen = newSideMenuStatus;
            }
        );

        $scope.$on('sideMenuStatusChanged', function (event, status) {
            $scope.issideMenuOpen = status;
            $scope.$apply();
        });


        /* Logo */
        logoService.getLogo($rootScope.user.subscriberId)
            .then(function (logo) {
                if (logo) {
                    $scope.logoImg = logo;
                }
            });


        /* Dashboards */
        $scope.dashboards = dashboardsService.dashboards;
        $scope.activeDashboard = dashboardsService.activeDashboard;

        $scope.$watch(
            function () {
                return dashboardsService.dashboards;
            },
            function (newDashboards, oldDashboards) {
                $scope.dashboards = newDashboards;
            }
        );

        $scope.$watch(
            function () {
                return dashboardsService.activeDashboard;
            },
            function (newActiveDashboard, oldActiveDashboard) {
                $scope.activeDashboard = newActiveDashboard;
            }
        );

        $scope.renameDashboard = function (dashboard) {

            sideMenuService.close();

            const scope = {
                name: dashboard.name
            };

            const template = 'templates/authenticated/layout/sideMenu/renameDashboard.html';

            modalService.openTopBarModal(template, scope)
                .then(function (newName) {
                    if (newName) {
                        dashboardsService.renameDashboard(dashboard, newName);
                    }
                });
        };

        $scope.deleteDashboard = function (dashboard) {
            sideMenuService.close();

            var scope = {
                title: 'Confirm Deletion',
                message: `Delete dashboard "${dashboard.name}"? This will result in the loss of all widgets on that dashboard.`
            };

            modalService.openTopBarModal(actionViewTemplates.confirmDialog, scope)
                .then(function (deleteConfirmed) {
                    if (deleteConfirmed) {
                        dashboardsService.deleteDashboard(dashboard);
                    }
                })
        }

        $scope.switchDashboards = function (dashboard) {
            sideMenuService.close();

            dashboardsService.switchDashboard(dashboard)
                .then(function (dashboard) {
                    $scope.activeDashboard = dashboard;
                });
        }




        /* Admin */
        $scope.openAdmin = function () {
            sideMenuService.close();

            var scope = {
                widgetName: 'Administration',
                widgetIcon: 'gear',
                widget: {
                    instance: {
                        id: 'subReg'
                    }
                },
                model: {
                    subscriberId: $rootScope.user.subscriberId,
                    itemName: 'Users',
                    status: constants.registrationStatus.live,
                    adminMode: true
                }
            };

            modalService
                .openActionView(actionViewTemplates.subRegDefault, scope, 'subReg');
        };


        /* User Impersonation */
        $scope.impersonateUser = function (user) {
            sideMenuService.close();

            userService.impersonateUser(user.subscriber.id, user.userId);
        }

        /* ADEPT */
        $scope.openAdeptInquiry = function () {

            sideMenuService.close();

            const scope = {
                widgetName: 'ADEPT Runs',
                widgetIcon: 'search',
                widgetId: 'AdeptInquiry',
                widgetCode: 'AdeptInquiry',
                settings: {},
                model: {}
            }

            modalService.openActionView(actionViewTemplates.adeptInquiryDefault, scope, 'AdeptInquiry');
        }

        /* Alerts */
        $scope.openAlertsManagement = function () {
            sideMenuService.close();

            const scope = {
                widgetName: 'Alerts Management',
                widgetIcon: `bell`,
                widgetId: 'AlertsManagement',
                widgetCode: 'AlertsManagement',
                settings: {},
                model: {}
            };

            modalService.openActionView(actionViewTemplates.alertsManagement, scope, 'AlertsManagement');
        }

        $scope.openAlertResults = function () {
            sideMenuService.close();

            const scope = {
                widgetName: 'Alert Results',
                widgetIcon: `table`,
                widgetId: 'AlertResults',
                widgetCode: 'AlertResults',
                settings: {},
                model: {
                    subscriberKey: null, 
                    alertKey: null
                }
            };

            modalService.openActionView(actionViewTemplates.alertResults, scope, 'AlertResults');
        }



        /* AMS */
        function openAmsReport(name, icon, code, templateUrl) {
            sideMenuService.close();

            var scope = {
                widgetId: code,
                widgetName: name,
                widgetIcon: icon,
                widgetCode: code,
                model: {
                    subscriberId: $rootScope.user.role != "sysadmin" ? $rootScope.user.subscriberId : null
                }
            };

            modalService.openActionView(templateUrl, scope, code);
        } 

        $scope.openMonitorInventory = function () {
            openAmsReport('Monitor Inventory', 'television', 'inventoryManagementController', actionViewTemplates.inventoryManagementController);
        };

        $scope.openMonitorComplianceReport = function () {
            openAmsReport('Monitor Compliance', 'table', 'tmsMonitorCompliance', actionViewTemplates.tmsMonitorComplianceReportContainer);
        }; 
 
        $scope.openActiveMonitorReport = function () {
            openAmsReport('Active Monitors', 'table', 'activeTankMonitorsController', actionViewTemplates.activeTankMonitors);
        };

        $scope.openWeeklyTankMonitoringUsageReport = function () {
            openAmsReport('Weekly Tank Monitoring Usage', 'calendar', 'tmsWeeklyTankMonitoringUsage', actionViewTemplates.tmsWeeklyTankMonitoringUsage);
        };




        /* Imports */
        function openImport(name, icon, code, templateUrl, gridHeaders, fileImportDataType, subscriber) {
            sideMenuService.close();

            var scope = {
                widgetId: code,
                widgetName: name,
                widgetIcon: icon,
                code,
                model: {
                    subscriberId: $rootScope.user.subscriberId,
                    gridHeaders,
                    dataTypeKey: fileImportDataType.dataTypeKey,
                    templateURL: fileImportDataType.templateURL,
                    product: fileImportDataType.product,
                    operation: fileImportDataType.operation,
                    subscriber: subscriber ? subscriber : $rootScope.user.subscriberId,
                }
            };

            modalService.openActionView(templateUrl, scope, code);
        }

        $scope.openImportTimeSheet = function () {
            openImport('Timesheet Import', 'cloud-upload', 'timesheetImport', actionViewTemplates.importFile, constantsService.importHeaders,
                constantsService.fileImportDataTypes.timesheetRobison);
        };

        $scope.openImportClosingQuote = function () {
            openImport('Closing Quotes Import', 'cloud-upload', 'closingQuotesImport', actionViewTemplates.importFile, constantsService.importHeaders,
                constantsService.fileImportDataTypes.closingQuotes, 'common');
        };

        $scope.openImportMonitorInventory = function() {
            openImport('Monitor Inventory Import', 'cloud-upload', 'monitorInventoryimport', actionViewTemplates.importFile, constantsService.importHeaders,
            constantsService.fileImportDataTypes.monitorInventory, 'common');
        };

        /* Tank */
        $scope.openTankOverview = function () {
            sideMenuService.close();

            const scope = {
                widgetName: 'Tank Overview',
                widgetIcon: ``,
                widgetImgIcon: '../../../../img/propane_icon_xs.png',
                widgetId: 'TankOverview',
                widgetCode: 'TankOverview',
                settings: {},
                model: {}
            };

            modalService.openActionView(actionViewTemplates.tankOverview, scope, 'TankOverview');
        }
        /* ADMIN */
        $scope.openInventoryTransactionReport = function () {
            sideMenuService.close();

            const scope = {
                widgetName: 'Inventory Transaction Report',
                widgetIcon: `clipboard`,
                widgetId: 'InventoryTransactionReport',
                widgetCode: 'InventoryTransactionReport',
                settings: {},
                model: {}
            };

            modalService.openActionView(actionViewTemplates.inventoryTransactionReport, scope, 'InventoryTransactionReport');
        }
        $scope.openUserReport = function () {

            sideMenuService.close();

            const scope = {
                widgetName: 'Users Report',
                widgetIcon: 'search',
                widgetId: 'UsersReport',
                widgetCode: 'UsersReport',
                settings: {},
                model: {
                }
            }

            modalService.openActionView(actionViewTemplates.usersReportDefault, scope, 'UsersReport');
        }

        $scope.openSysAdminTools = function () {

            sideMenuService.close();

            const scope = {
                widgetName: 'SysAdmin Tools',
                widgetIcon: 'gear',
                widgetId: 'SysAdminTools',
                widgetCode: 'SysAdminTools',
                settings: {},
                model: {
                }
            }

            modalService.openActionView(actionViewTemplates.sysAdminToolsDefault, scope, 'SysAdminTools');
        }
        /* Snapshot */
        $scope.loadSnapShot = function(report) {
            sideMenuService.close();

            var scope = {
                widgetId: report,
                widgetName: 'Snapshots',
                widgetIcon: 'camera',
                widgetCode: 'snapShots',
                model: { report: report }
            };

            modalService
                .openActionView(actionViewTemplates.snapShotsDefault, scope, 'snapShot');
        };
        
    }]);
